import { useState } from "react";
import BulkATCPopup from "~/features/bulkAddToCart/components/BulkATCPopup";

export const MergeCustomerCart = () => {
  const [showModal, setShowModal] = useState(window.SCHA.runCartMerge);

  if (!showModal) {
    return null;
  }

  return <BulkATCPopup mergeCartFlow onClose={() => setShowModal(false)} />;
};
